/**
 * Centralized configuration for all available calculators.
 * Used to populate the "Other Calculators" dropdown in the header
 * and to define routes in index.js.
 *
 * Each calculator has:
 * - name: Display name shown in the dropdown
 * - path: Route path used for navigation
 * - icon: Bootstrap icon class suffix (e.g. "house" => "bi bi-house")
 * - blurb: One line for the calculators page, sentence case, no selling
 * - group: Grouping used by the header menu and the calculators page
 */
export const topCalculatorPaths = ["/", "/income-tax", "/take-home-pay", "/mortgage"];

const calculatorData = [
  { name: "Student Loan Calculator", path: "/", blurb: "Repayments, interest and write-off on Plan 1, 2, 4, 5 and postgraduate loans.", icon: "calculator", group: "student" },
  {
    name: "Student Budget",
    path: "/student-budget",
    blurb: "Money in and out over the year, brought to a weekly figure.",
    icon: "calculator",
    group: "student",
  },
  {
    name: "Income Tax Calculator",
    path: "/income-tax",
    blurb: "Income tax, National Insurance and the full deductions breakdown.",
    icon: "receipt-cutoff",
    group: "tax",
  },
  {
    name: "Take-Home Pay Calculator",
    path: "/take-home-pay",
    blurb: "Pay after tax, NI, pension and student loan, monthly and yearly.",
    icon: "wallet2",
    group: "tax",
  },
  {
    name: "Required Salary Calculator",
    path: "/required-salary",
    blurb: "Gross salary needed for a target take-home amount.",
    icon: "arrow-up-right",
    group: "tax",
  },
  {
    name: "Pro-Rata Pay Calculator",
    path: "/pro-rata-pay",
    blurb: "Reduced hours and paid weeks, with gross and net pay compared.",
    icon: "clock",
    group: "tax",
  },
  {
    name: "Marginal Rate Calculator",
    path: "/marginal-rate",
    blurb: "How much of the next £1 of pay you keep.",
    icon: "graph-up",
    group: "tax",
  },
{ name: "Income Percentiles", path: "/income-percentile", blurb: "Your income against the historical UK taxpayer distribution.", icon: "bar-chart", group: "tax" },
  {
    name: "Mortgage Calculator",
    path: "/mortgage",
    blurb: "Monthly repayments, total interest and the balance over time.",
    icon: "house-heart",
    group: "housing",
  },
  {
    name: "How Much Can I Borrow",
    path: "/how-much-can-i-borrow",
    blurb: "The loan and price your income, deposit and outgoings support.",
    icon: "house-add",
    group: "housing",
  },
  {
    name: "First Home Calculator",
    path: "/first-home",
    blurb: "Deposit date, LISA bonus and the cost of buying.",
    icon: "house-door",
    group: "housing",
  },
  {
    name: "Stamp Duty Calculator",
    path: "/stamp-duty",
    blurb:
      "UK property tax, with first-time buyer and additional property rates.",
    icon: "building",
    group: "housing",
  },
  {
    name: "Overpayment Calculator",
    path: "/mortgage/overpayments",
    blurb: "What paying extra saves in interest and years.",
    icon: "currency-pound",
    group: "housing",
  },
  {
    name: "Remortgage Calculator",
    path: "/remortgage",
    blurb:
      "Stay or switch: the saving over the deal with fees and charges counted.",
    icon: "arrow-repeat",
    group: "housing",
  },
  {
    name: "Rent or Buy Calculator",
    path: "/rent-vs-buy",
    blurb: "Net assets with equal budgets, fees and invested savings.",
    icon: "house-door",
    group: "housing",
  },
  {
    name: "Money Planner",
    path: "/money-planner",
    blurb: "Where each month's surplus goes, in a sensible order.",
    icon: "signpost-split",
    group: "wealth",
  },
  {
    name: "Savings Goal Calculator",
    path: "/savings-goal",
    blurb: "How long a target takes at a monthly amount and rate.",
    icon: "piggy-bank-fill",
    group: "wealth",
  },
  {
    name: "Pension Calculator",
    path: "/pension",
    blurb: "Pot at retirement and the income it could pay.",
    icon: "piggy-bank",
    group: "wealth",
  },
  {
    name: "Investment Calculator",
    path: "/investment",
    blurb: "How regular investing compounds over time.",
    icon: "graph-up-arrow",
    group: "wealth",
  },
  {
    name: "FIRE Calculator",
    path: "/fire",
    blurb: "The pot you need to stop working, and how long it takes.",
    icon: "fire",
    group: "wealth",
  },
  {
    name: "Inflation Calculator",
    path: "/inflation",
    blurb: "Future prices and purchasing power at an assumed inflation rate.",
    icon: "graph-up",
    group: "wealth",
  },
  {
    name: "Car Loan Calculator",
    path: "/car-loan",
    blurb: "Monthly payments and the full cost of car finance.",
    icon: "car-front",
    group: "borrowing",
  },
  {
    name: "Credit Card Payoff",
    path: "/credit-card",
    blurb: "How long a balance takes to clear, and the interest.",
    icon: "credit-card",
    group: "borrowing",
  },
  {
    name: "Debt Payoff",
    path: "/debt-payoff",
    blurb:
      "Snowball or avalanche: which order clears your debts sooner and cheaper.",
    icon: "snow",
    group: "borrowing",
  },
  {
    name: "Compare Job Offers",
    path: "/compare-job-offers",
    blurb: "Compare take-home pay, pension contributions, working hours and job costs.",
    icon: "briefcase",
    group: "tax",
  },
  { name: "RSU Calculator", path: "/rsu-calculator", blurb: "Estimate tax, sell-to-cover and retained value when shares vest.", icon: "graph-up-arrow", group: "tax" },
  { name: "Share Options Calculator", path: "/share-options", blurb: "Compare option exercise outcomes for EMI, CSOP, SAYE and ordinary options.", icon: "ticket-perforated", group: "tax" },
  { name: "Share Incentive Plan", path: "/share-incentive-plan", blurb: "Explore free, partnership, matching and dividend share withdrawal rules.", icon: "people", group: "tax" },
];

export default calculatorData;
